import { render, staticRenderFns } from "./masterdata-size-chart-preview.vue?vue&type=template&id=0acfac87&scoped=true&lang=pug"
import script from "./masterdata-size-chart-preview.vue?vue&type=script&lang=ts"
export * from "./masterdata-size-chart-preview.vue?vue&type=script&lang=ts"
import style0 from "./masterdata-size-chart-preview.vue?vue&type=style&index=0&id=0acfac87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfac87",
  null
  
)

export default component.exports